// SEO utility functions

import { PRODUCT_BRAND, SITE_ORIGINS } from "@/config/platform";
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + "...";
};

export const generateMetaTitle = (title: string): string => {
  return truncateText(title, 60);
};

export const generateMetaDescription = (description: string): string => {
  return truncateText(description, 160);
};

export const generateKeywords = (keywords: string[]): string => {
  return keywords.join(", ");
};

export const createCanonicalUrl = (baseUrl: string, path: string): string => {
  return `${baseUrl.replace(/\/$/, "")}${path}`;
};

export const generateImageAlt = (context: string, mainKeyword?: string): string => {
  const base = context;
  return mainKeyword ? `${base} - ${mainKeyword}` : base;
};

// Common SEO configurations
export const SEO_CONFIG = {
  baseUrl: SITE_ORIGINS.pt,
  siteName: PRODUCT_BRAND,
  defaultImage: `${SITE_ORIGINS.pt}/og-image.png`,
  twitterHandle: "@DENVORAMobility",
  organizationName: PRODUCT_BRAND,
  defaultKeywords: [
    "Portugal real estate",
    "Golden Visa Portugal", 
    "Portugal investment",
    "Portugal residency",
    "Buy property Portugal",
    "Portugal visas"
  ]
};

export const PAGE_TYPES = {
  HOME: "website",
  ARTICLE: "article", 
  SERVICE: "service",
  PRODUCT: "product"
} as const;